var React = require('react');

function Seo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.372 0h-5.734a.823.823 0 00-.834.834c0 .47.39.86.86.86h3.7l-9.903 9.904-2.033-2.033a.834.834 0 00-1.199 0l-4.196 4.196a7.028 7.028 0 01-.339-2.215C1.694 7.558 4.952 4.3 8.94 4.3c1.485 0 2.893.443 4.04 1.225l1.198-1.199c-1.485-1.068-3.284-1.72-5.238-1.72C4.014 2.606 0 6.62 0 11.546a8.91 8.91 0 008.914 8.914 8.873 8.873 0 005.681-2.06l6.1 6.1c.155.156.39.26.599.26a.792.792 0 00.6-.26.834.834 0 000-1.2l-6.1-6.072a8.926 8.926 0 002.06-5.682 9.03 9.03 0 00-.496-2.92l-1.355 1.356c.104.495.182 1.017.182 1.538 0 3.988-3.258 7.245-7.245 7.245-2.58 0-4.874-1.38-6.151-3.414.026-.026.052-.026.078-.052l3.935-3.935 2.033 2.032a.834.834 0 001.2 0L20.537 2.893v3.701c0 .47.365.834.834.834s.834-.365.834-.834V.86c.026-.495-.365-.86-.834-.86z"}));
}

Seo.defaultProps = {"width":"23","height":"25","viewBox":"0 0 23 25"};

module.exports = Seo;

Seo.default = Seo;
